(function($) {

  'use strict';

  function SlideParallax() {

    var self = this,
      $cache = {},
      swiperIsInit = false,
      swiper = false,
      controller_slides = false,
      scenes_slides = [],
      controller_animations = false,
      scenes_animations = [];

    function createSlidesScene() {
      if(!controller_slides) return;

      // get all slides
      var slides = document.querySelectorAll(".section-slide");
      

      // create scene for every slide
      for (var i=0; i<slides.length; i++) {

        var scene = new ScrollMagic.Scene({
                      triggerElement: slides[i],
                      loglevel: 3
                    });

        if(i < slides.length - 1) scene.setPin(slides[i], {pushFollowers: false});
        scene.addTo(controller_slides);

        scenes_slides.push(scene);
      }
    }

    function createAnimationScenes() {
      if(!controller_animations) return;

      //Slide 1
      var $slide1 = $cache.swiperSlides.eq(0);
      var $itemsArray = $slide1.find('.js-animate-rlo').toArray();
      var $itemsReverse = $itemsArray.reverse();

      var tl = new TimelineMax();
      tl.staggerFromTo($itemsReverse, 1, {x: 0}, {x: -200, force3D:true, ease: Quad.easeOut}, 0.075, 0);
      tl.staggerFromTo($itemsReverse, 0.8, {opacity: 1}, {opacity: 0, ease: Quad.easeOut}, 0.075, 0);

      var scene = new ScrollMagic.Scene({
            triggerElement: $slide1[0],
          })
          .setTween(tl)
          //.addIndicators() // add indicators (requires plugin)
          .addTo(controller_animations);
      scenes_animations.push(scene);

      //Slide 2 - In
      var $slide2 = $cache.swiperSlides.eq(1);
      var tl = new TimelineMax();
      tl.fromTo($slide2.find('.carousel__main-title'), 1, {opacity: 0}, {opacity: 1, ease: Quad.easeOut}, 0.2);
      tl.fromTo($slide2.find('.carousel__main-title'), 1.3, {y: 150}, {y: 0, force3D:true, ease: Quad.easeOut}, 0.2);

      tl.fromTo($slide2.find('.js-carousel-logo'), 1, {opacity: 0}, {opacity: 1, ease: Quad.easeOut}, 0.2);
      tl.fromTo($slide2.find('.js-carousel-logo'), 1.3, {y: 150}, {y: 0, force3D:true, ease: Quad.easeOut}, 0.2);

      tl.fromTo($slide2.find('.carousel-text'), 1, {opacity: 0}, {opacity: 1, ease: Quad.easeOut}, 0.6);
      tl.fromTo($slide2.find('.carousel-text'), 1.3, {y: 150}, {y: 0, force3D:true, ease: Quad.easeOut}, 0.6);

      tl.fromTo($slide2.find('.carousel__navigation'), 1, {opacity: 0}, {opacity: 1, ease: Quad.easeOut}, 0.9);

      var scene = new ScrollMagic.Scene({
            triggerElement: $slide1[0],
            offset: $cache.swiperSlides.height()*0.25
          })
          .setTween(tl)
          //.addIndicators() // add indicators (requires plugin)
          .addTo(controller_animations);
      scenes_animations.push(scene);


      //Slide 2 - Out
      var tl = new TimelineMax();
      tl.fromTo($slide2.find('.carousel__main-title'), 1, {opacity: 1}, {opacity: 0, ease: Quad.easeOut}, 0.5);
      tl.fromTo($slide2.find('.carousel__main-title'), 1.3, {y: 0}, {y: -150, force3D:true, ease: Quad.easeOut}, 0.5);
      
      tl.fromTo($slide2.find('.js-carousel-logo'), 1, {opacity: 1}, {opacity: 0, ease: Quad.easeOut}, 0.5);
      tl.fromTo($slide2.find('.js-carousel-logo'), 1.3, {y: 0}, {y: -150, force3D:true, ease: Quad.easeOut}, 0.5);

      tl.fromTo($slide2.find('.carousel-text'), 1, {opacity: 1}, {opacity: 0, ease: Quad.easeOut}, 0);
      tl.fromTo($slide2.find('.carousel-text'), 1.3, {y: 0}, {y: -150, force3D:true, ease: Quad.easeOut}, 0);

      tl.fromTo($slide2.find('.carousel__navigation'), 1, {opacity: 1}, {opacity: 0, ease: Expo.easeOut}, 0);

      var scene = new ScrollMagic.Scene({
            offset: $cache.swiperSlides.height()*0.15,
            triggerElement: $slide2[0],
          })
          .setTween(tl)
          //.addIndicators() // add indicators (requires plugin)
          .addTo(controller_animations);
      scenes_animations.push(scene);


      //Slide 3 - In
      var $slide3 = $cache.swiperSlides.eq(2);
      var tl = new TimelineMax();
      tl.fromTo($slide3.find('.carousel__main-title'), 1, {opacity: 0}, {opacity: 1, ease: Quad.easeOut}, 0.2);
      tl.fromTo($slide3.find('.carousel__main-title'), 1.3, {y: 150}, {y: 0, force3D:true, ease: Quart.easeOut}, 0.2);

      tl.fromTo($slide3.find('.carousel-text'), 1, {opacity: 0}, {opacity: 1, ease: Quad.easeOut}, 0.5);
      tl.fromTo($slide3.find('.carousel-text'), 1.3, {y: 150}, {y: 0, force3D:true, ease: Quart.easeOut}, 0.5);

      tl.fromTo($slide3.find('.carousel__navigation'), 1, {opacity: 0}, {opacity: 1, ease: Quad.easeOut}, 0.9);

      var scene = new ScrollMagic.Scene({
            triggerElement: $slide2[0],
            offset: $cache.swiperSlides.height()*0.25
          })
          .setTween(tl)
          //.addIndicators() // add indicators (requires plugin)
          .addTo(controller_animations);
      scenes_animations.push(scene);

      //Slide 3 - Out
      var tl = new TimelineMax();
      tl.fromTo($slide3.find('.carousel__main-title'), 1, {opacity: 1}, {opacity: 0, ease: Quad.easeOut}, 0.5);
      tl.fromTo($slide3.find('.carousel__main-title'), 1.3, {y: 0}, {y: -150, force3D:true, ease: Quad.easeOut}, 0.5);

      tl.fromTo($slide3.find('.carousel-text'), 1, {opacity: 1}, {opacity: 0, ease: Quad.easeOut}, 0);
      tl.fromTo($slide3.find('.carousel-text'), 1.3, {y: 0}, {y: -150, force3D:true, ease: Quad.easeOut}, 0);

      tl.fromTo($slide3.find('.carousel__navigation'), 1, {opacity: 1}, {opacity: 0, ease: Expo.easeOut}, 0);

      var scene = new ScrollMagic.Scene({
            offset: $cache.swiperSlides.height()*0.15,
            triggerElement: $slide3[0],
          })
          .setTween(tl)
          //.addIndicators() // add indicators (requires plugin)
          .addTo(controller_animations);
      scenes_animations.push(scene);

      //Slide 4
      var $slide4 = $cache.swiperSlides.eq(3);
      var $items = $slide4.find('.clients-list__container > *');

      var tl = new TimelineMax();
      tl.staggerFromTo($items, 1,{opacity: 0}, {opacity: 1, ease: Quad.easeOut}, 0.075, 0);
      tl.staggerFromTo($items, 1.3, {x: 150}, {x: 0, force3D:true, ease: Quad.easeOut}, 0.075, 0);

      var scene = new ScrollMagic.Scene({
            triggerElement: $slide3[0],
            offset: $cache.swiperSlides.height()*0.35
          })
          .setTween(tl)
          //.addIndicators() // add indicators (requires plugin)
          .addTo(controller_animations);
      scenes_animations.push(scene);
    }

    function initSwiper() {
      if(swiperIsInit || env.device.mobile || env.device.touch) return;
      swiperIsInit = true;

      controller_slides = new ScrollMagic.Controller({
        globalSceneOptions: {
          loglevel: 3,
          triggerHook: 'onLeave',
          duration: "0" // this works just fine with duration 0 as well
          // However with large numbers (>20) of pinned sections display errors can occur so every section should be unpinned once it's covered by the next section.
          // Normally 100% would work for this, but here 200% is used, as Panel 3 is shown for more than 100% of scrollheight due to the pause.
        }
      });

      controller_animations = new ScrollMagic.Controller({ 
        globalSceneOptions: {
          triggerHook: 'onLeave',
          duration: $cache.swiperSlides.height()*0.75
        }
      });

      if(window.cache.$window.width() >= 768) createSlidesScene();
      if(window.cache.$window.width() >= 768) createAnimationScenes();
    }

    function onResize() {
      if(!swiperIsInit) return;

      if(scenes_slides.length > 0) {
        // Destroy scenes
        $.each(scenes_slides, function(index, scene){
          scene.destroy(true);
        });
      }

      if(scenes_animations.length > 0) {
        // Destroy scenes
        $.each(scenes_animations, function(index, scene){
          scene.destroy(true);
        });
      }

      if(window.cache.$window.width() >= 768) {
        // On desktop create slides
        createSlidesScene();
        createAnimationScenes();
      } else {
        // Animation settings (from) for element on mobile
        var $slide1 = $cache.swiperSlides.eq(0);
        $slide1.find('.js-animate-rlo').removeProp('style');

        var $slide2 = $cache.swiperSlides.eq(1);
        $slide2.find('.carousel__main-title').removeProp('style');
        $slide2.find('.js-carousel-logo').removeProp('style');
        $slide2.find('.carousel-text').removeProp('style');
        $slide2.find('.carousel__navigation').removeProp('style');

        var $slide3 = $cache.swiperSlides.eq(2);
        $slide3.find('.carousel__main-title').removeProp('style');
        $slide3.find('.carousel-text').removeProp('style');
        $slide3.find('.carousel__navigation').removeProp('style');

        var $slide4 = $cache.swiperSlides.eq(3);
        $slide4.find('.clients-list__container > *').removeProp('style');
      }
    }

    function initCache() {
      $cache.swiper = $cache.main;
      $cache.swiperSlides = $cache.swiper.find('> .section-wrapper > .section-slide');
    }

    function registerEvents() {
      window.cache.$window.on('resize', onResize);
    }

    /**
     * Public constructor
     * @param  {Object} opts Options
     */
    self.initialize = function(opts) {
      //Caching
      $cache.main = opts.$el;

      initCache();
      registerEvents();

      setTimeout(initSwiper, 200);
    };

    self.initialize.apply(self, arguments);
    return self;
  }

  /* Namespace declaration */
  window.SlideParallax = SlideParallax;

}(jQuery));